import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppProvider } from './contexts/AppContext';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { Crowdfunding } from './pages/Crowdfunding';
import { DiasporaExchange } from './pages/DiasporaExchange';
import { BillPayment } from './pages/BillPayment';
import { FacilityManagement } from './pages/FacilityManagement';
import { Wallet } from './pages/Wallet';
import { Settings } from './pages/Settings';
import { Homepage } from './pages/Homepage';
import { GuestDonate } from './pages/GuestDonate';
import { Signup } from './pages/Signup';
export function App() {
  return <AppProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Toaster position="top-right" richColors data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Homepage data-id="element-5" />} data-id="element-4" />
          <Route path="/login" element={<Login data-id="element-7" />} data-id="element-6" />
          <Route path="/signup" element={<Signup data-id="element-9" />} data-id="element-8" />
          <Route path="/donate" element={<GuestDonate data-id="element-11" />} data-id="element-10" />

          <Route path="/dashboard" element={<DashboardLayout data-id="element-13" />} data-id="element-12">
            <Route index element={<Overview data-id="element-15" />} data-id="element-14" />
            <Route path="crowdfunding" element={<Crowdfunding data-id="element-17" />} data-id="element-16" />
            <Route path="diaspora" element={<DiasporaExchange data-id="element-19" />} data-id="element-18" />
            <Route path="bills" element={<BillPayment data-id="element-21" />} data-id="element-20" />
            <Route path="facility" element={<FacilityManagement data-id="element-23" />} data-id="element-22" />
            <Route path="wallet" element={<Wallet data-id="element-25" />} data-id="element-24" />
            <Route path="settings" element={<Settings data-id="element-27" />} data-id="element-26" />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-29" />} data-id="element-28" />
        </Routes>
      </BrowserRouter>
    </AppProvider>;
}